<div class="vh-100" style="color: var(--bs-white);">
  <div class="row">
    <div class="col-12 text-center">
      <h4 class="mt-2 mb-2">API Documentation</h4>
    </div>
  </div>

  <ng-container *ngFor="let data of apiData;let i = index;">
    <div class="card">
      <div class="card-header row" (click)="expandcollapse(i);">
        <div class="col-11">
          <ng-container *ngIf="data.displayName !== 'Common Model'">
            <button type="button" class="btn btn-light">POST</button>
          </ng-container>
          <button type="button" class="btn btn-link">{{data?.displayName}}</button>
        </div>
        <div class="col-1 align-self-center text-end">
          <ng-container *ngIf="!expandorCollapseList[i]">
            <i class="fa fa-chevron-up"></i>
          </ng-container>
          <ng-container *ngIf="expandorCollapseList[i]">
            <i class="fa fa-chevron-down"></i>
          </ng-container>
        </div>
      </div>

      <div class="card-body row" id="expand-card-{{i}}" style="display: none" *ngIf="expandorCollapseList[i]">
        <div class="col-12">
          <ng-container *ngIf="data?.url">
            <div class="containt">
              <b>URL : </b>
              <div class="box" title="Copy URL" (click)="copyToClipBoard('#URL');">
                <pre id="URL">{{data?.url}}</pre>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="data?.header">
            <div class="containt">
              <b>Header : </b>
              <div class="box" title="Copy Header" (click)="copyToClipBoard('#Header');">
                <pre id="Header">{{data?.header}}</pre>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="data?.request">
            <div class="containt">
              <b>Request : </b>
              <div class="box" title="Copy Request" (click)="copyToClipBoard('#Request');">
                <pre id="Request">{{data?.request}}</pre>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="data?.requestPlacebet">
            <div class="containt">
              <b>Request Placebet : </b>
              <div class="box" title="Copy Request Placebet" (click)="copyToClipBoard('#RequestPlacebet');">
                <pre id="RequestPlacebet">{{data?.requestPlacebet}}</pre>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="data?.requestPlacebetCancel">
            <div class="containt">
              <b>Request Placebet Cancel : </b>
              <div class="box" title="Copy Request Placebet Cancel"
                (click)="copyToClipBoard('#RequestPlacebetCancel');">
                <pre id="RequestPlacebetCancel">{{data?.requestPlacebetCancel}}</pre>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="data?.successResponse">
            <div class="containt">
              <b>Success Response : </b>
              <div class="box" title="Copy Success Response" (click)="copyToClipBoard('#SuccessResponse');">
                <pre id="SuccessResponse">{{data?.successResponse}}</pre>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="data?.failResponse">
            <div class="containt">
              <b>Fail Response : </b>
              <div class="box" title="Copy Fail Response" (click)="copyToClipBoard('#FailResponse');">
                <pre id="FailResponse">{{data?.failResponse}}</pre>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="data?.commonModelList && data.commonModelList.length > 0">
            <ng-container *ngFor="let commonModel of data.commonModelList">
              <div class="containt">
                <b>{{commonModel?.title}} : </b>
                <div class="box">
                  <pre>{{commonModel?.data}}</pre>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</div>